import {
  axios,
  saveToLocalStorage,
  deleteFromLocalStorage,
  INITAL_TABLE_CONFIG,
} from '@/lib/helpers';
import { _setTableConfig, setProducts, fetchProducts } from '@/lib/redux/redux-actions';
import { createAction } from '@reduxjs/toolkit';

export const setActiveSearch = createAction('products-search/active-search/set');

export const setActiveOperator = createAction('products-search/active-operator/set');
export const _setActiveOperator = (activeOperator) => (dispatch) => {
  dispatch(setActiveOperator({ searchOperator: activeOperator }));
  saveToLocalStorage('activeOperator', activeOperator);
};

export const setOverrideSearch = createAction('products-search/override-search/set');
export const _setOverrideSearch = (overrideSearch) => (dispatch) => {
  saveToLocalStorage('overrideSearch', overrideSearch);
  dispatch(setOverrideSearch(overrideSearch));
};

export const setActiveFilters = createAction('products-search/active-filters/save');
export const _setActiveFilters = (activeFilters) => (dispatch, getState) => {
  const currentState = getState();
  const tableConfigsState = currentState.tableConfigs;
  const { productsListConfig } = tableConfigsState;

  dispatch(setActiveFilters({ activeFilters }));
  dispatch(
    _setTableConfig('productsListConfig', {
      ...INITAL_TABLE_CONFIG,
      rowsPerPage: productsListConfig.rowsPerPage,
    })
  );
  saveToLocalStorage('activeFilters', activeFilters);
};

export const _setActiveSearch = (savedSearch) => (dispatch, getState) => {
  const currentState = getState();
  const tableConfigsState = currentState.tableConfigs;
  const { productsListConfig } = tableConfigsState;

  if (savedSearch === null) {
    deleteFromLocalStorage('activeSearch');
    deleteFromLocalStorage('activeFilters');
    dispatch(setProducts([]));
  } else {
    saveToLocalStorage('activeSearch', savedSearch);
    saveToLocalStorage('activeFilters', savedSearch.searchFilters);
  }
  dispatch(
    _setTableConfig('productsListConfig', {
      ...INITAL_TABLE_CONFIG,
      rowsPerPage: productsListConfig.rowsPerPage,
    })
  );
  dispatch(setActiveSearch({ savedSearch: savedSearch || null }));
};

export const copyActiveSearch = () => (dispatch, getState) => {
  const currentState = getState();
  const productsSearchState = currentState.productsSearch;
  const { activeFilters, activeOperator } = productsSearchState;
  const _activeFilters = Object.keys(activeFilters).reduce(
    (acc, key) => ({
      ...acc,
      [key]: {
        ...activeFilters[key],
        filterUseOr: '0',
      },
    }),
    {}
  );
  dispatch(_setActiveSearch(null));
  dispatch(_setActiveOperator(activeOperator));
  dispatch(_setActiveFilters(_activeFilters));
  dispatch(_setOverrideSearch(false));
  dispatch(fetchProducts(_activeFilters, activeOperator));
};

export const productsSearchRequestStarted = createAction('products-search/request/started');
export const productsSearchRequestFailed = createAction('products-search/request/failed');

export const fetchSavedSearchesSucceeded = createAction('products-search/fetch/succeeded');
export const fetchSavedSearches = (userUuid) => (dispatch, getState) => {
  const currentState = getState();
  const userState = currentState.user;
  const { chainUrls } = userState;

  if (!Object.keys(chainUrls).length) {
    return;
  }

  dispatch(productsSearchRequestStarted());

  return axios({
    method: 'get',
    crossdomain: true,
    url: `${chainUrls.GET_SAVED_SEARCHES}userUuid=${userUuid}`,
  }).then(({ status, data }) => {
    if (status.toString().startsWith('4')) {
      dispatch(productsSearchRequestFailed());
    } else {
      dispatch(fetchSavedSearchesSucceeded(data.result));
    }
  });
};

export const postSavedSearchSucceeded = createAction('products-search/post/succeeded');
export const postSavedSearch = (requestData) => (dispatch, getState) => {
  dispatch(productsSearchRequestStarted());

  const currentState = getState();
  const userState = currentState.user;
  const { chainUrls } = userState;

  return axios({
    method: 'post',
    data: requestData,
    url: `${chainUrls.POST_SAVED_SEARCH}`,
  }).then(
    ({ data }) => {
      if (data.result.savedSearch) {
        saveToLocalStorage('activeSearch', data.result.savedSearch);
        saveToLocalStorage('activeFilters', data.result.savedSearch.searchFilters);
        dispatch(postSavedSearchSucceeded(data.result));
      } else {
        dispatch(productsSearchRequestFailed('data.result.savedSearch missing'));
      }
    },
    ({ message }) => dispatch(productsSearchRequestFailed(message))
  );
};

export const editSavedSearchSucceeded = createAction('products-search/edit/succeeded');
export const editSavedSearch =
  (search, filters, operator, newSearchName) => (dispatch, getState) => {
    dispatch(productsSearchRequestStarted());

    const requestData = {
      ...search,
      searchOperator: operator,
      filters: JSON.stringify(filters),
      searchName: newSearchName || search.searchName,
    };

    const { searchUuid, userUuid } = requestData;

    const currentState = getState();
    const userState = currentState.user;
    const { chainUrls } = userState;

    return axios({
      method: 'put',
      data: requestData,
      url: `${chainUrls.PUT_SAVED_SEARCH}searchUuid=${searchUuid}&userUuid=${userUuid}`,
    }).then(
      ({ data }) => {
        if (data.result) {
          dispatch(editSavedSearchSucceeded(data.result.searches));
          dispatch(_setActiveSearch(data.result.editedSearch));
        }
      },
      ({ message }) => dispatch(productsSearchRequestFailed(message))
    );
  };

export const deleteSavedSearchSucceeded = createAction('products-search/delete/succeeded');
export const deleteSavedSearch = (searchUuid, userUuid) => (dispatch, getState) => {
  dispatch(productsSearchRequestStarted());

  const currentState = getState();
  const userState = currentState.user;
  const { chainUrls } = userState;

  return axios({
    method: 'delete',
    data: { searchUuid },
    url: `${chainUrls.DELETE_SAVED_SEARCH}userUuid=${userUuid}`,
  }).then(
    ({ data }) => dispatch(deleteSavedSearchSucceeded(data.result)),
    ({ message }) => dispatch(productsSearchRequestFailed(message))
  );
};
